import React from "react";
import { css } from "@emotion/react";
import { FieldLabel } from "@moneyforward/mfx_biz_react_components";
import { useIsSpMode } from "@/hooks";
import { middleNameValidation } from "@/components/validations";
import { FormErrorMessage, FormTextField } from "@/components/molecules";

type Props = {
  name: string;
};

const MiddleNameFormFieldMain = (
  props: Props,
  ref: React.ForwardedRef<HTMLInputElement>
) => {
  const isSpMode = useIsSpMode();
  return (
    <div css={!isSpMode ? container : {}}>
      <div css={labelWrapper}>
        <FieldLabel>ミドルネーム</FieldLabel>
      </div>
      <div css={inputWrapper}>
        <FormTextField
          name={props.name}
          placeholder={"例) Alois"}
          registerOptions={{
            validate: middleNameValidation,
          }}
          ref={ref}
        />
        <div css={errorWrapper}>
          <FormErrorMessage name={props.name} />
        </div>
      </div>
    </div>
  );
};

export const MiddleNameFormField = React.forwardRef(MiddleNameFormFieldMain);

const container = css({
  display: "flex",
});

const labelWrapper = css({
  width: "160px",
  marginRight: "16px",
  paddingTop: "10px",
  paddingBottom: "4px",
});

const inputWrapper = css({
  width: "100%",
  flex: 1,
});

const errorWrapper = css({
  flex: 1,
});
